import styled from 'styled-components'

import { CircularProgress as MuiCircularProgress } from '@material-ui/core'

export default styled(MuiCircularProgress)`
  &.MuiCircularProgress-colorPrimary {
    color: var(--white);
  }
`
